import React from "react";
import { Menubar } from "primereact/menubar";
import { NavLink  } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import styles from "./page.module.scss";

import { Button } from "primereact/button";
import { FaFileAlt } from "react-icons/fa";
import { LuLogOut } from "react-icons/lu";
import { RiContactsFill } from "react-icons/ri";
import { FaDollarSign } from "react-icons/fa";
import { FaShippingFast } from "react-icons/fa";
export default function AdminHeader() {
  const items = [
    {
      template: () => (
        <NavLink
          to="/shah-admin/applications"
          className={({ isActive }) =>
            `flex align-items-center gap-2 ${styles.adminMenuLink} ${
              isActive ? styles.active : "inactive"
            }`
          }
        >
          <FaFileAlt />
          <span>Applications</span>
        </NavLink>
      ),
    },
    {
      template: () => (
        <NavLink
          to="/shah-admin/contact-requests"
          className={({ isActive }) =>
            `flex align-items-center gap-2 ${styles.adminMenuLink} ${
              isActive ? styles.active : "inactive"
            }`
          }
        >
          <RiContactsFill />
          <span>Contact Request</span>
        </NavLink>
      ),
    },
    {
      template: () => (
        <NavLink
          to="/shah-admin/quote-requests"
          className={({ isActive }) =>
            `flex align-items-center gap-2 ${styles.adminMenuLink} ${
              isActive ? styles.active : "inactive"
            }`
          }
        >
          <FaDollarSign />
          <span>Quote Requests</span>
        </NavLink>
      ),
    },
    {
      template: () => (
        <NavLink
          to="/shah-admin/shipping-calculations"
          className={({ isActive }) =>
            `flex align-items-center gap-2 ${styles.adminMenuLink} ${
              isActive ? styles.active : "inactive"
            }`
          }
        >
          <FaShippingFast />
          <span>Shipping Calculations</span>
        </NavLink>
      ),
    },

    {
      template: () => (
        <Button
          label="Logout"
          severity="secondary"
          className="flex flex-row-reverse"
          text
          raised
          icon={<LuLogOut className="ml-2" />}
        />
      ),
    },
  ];

  const start = <img src={Logo} alt="Shah transport" width={130} height={50} />;

  return (
    <Menubar
      model={items}
      className="flex justify-content-between px-5"
      start={start}
    />
  );
}
